export default __webpack_public_path__ + "static/media/icon-logout.af0d27e9.svg";